/**
 * Whether a place sits inside another one in the places tree: a ride inside
 * its park, a lounge inside its airport. `parentOf` looks up one entity's
 * `parentId` (null at the top, or when it can't be read).
 *
 * The log flow asks this to decide where a pick belongs. Picking a ride while
 * checked in at its park files it under the park; picking SFO while a hotel
 * visit is still open does not, because SFO isn't in the hotel.
 */
export async function isPlaceInside(
  entityId: string,
  containerId: string,
  parentOf: (id: string) => Promise<string | null>,
  maxDepth = 8,
): Promise<boolean> {
  const seen = new Set<string>([entityId]);
  let current: string | null = entityId;
  for (let i = 0; i < maxDepth && current; i++) {
    const next: string | null = await parentOf(current);
    if (!next || seen.has(next)) return false;
    if (next === containerId) return true;
    seen.add(next);
    current = next;
  }
  return false;
}
